// extracted by mini-css-extract-plugin
export default {"userManagement":"UserManagement_userManagement__FE4pZ","contentTitle":"UserManagement_contentTitle__VO4Tq"};